import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const WhatsNewIcon = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_562_1921)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M2.25 11.8125V6.1875L4.5 11.8125V6.1875",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M9 11.8125H7.875C7.57663 11.8125 7.29048 11.694 7.0795 11.483C6.86853 11.272 6.75 10.9859 6.75 10.6875V7.3125C6.75 7.01413 6.86853 6.72798 7.0795 6.517C7.29048 6.30603 7.57663 6.1875 7.875 6.1875H9",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M6.75 9.5625H9",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M11.25 6.1875V7.70025C11.2498 8.5589 11.4137 9.40967 11.733 10.2068L12.375 11.8125L13.5 7.875L14.625 11.8125L15.267 10.2068C15.586 9.40957 15.7499 8.55887 15.75 7.70025V6.1875",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M17.4375 14.0625V16.3125C17.4375 16.6109 17.319 16.897 17.108 17.108C16.897 17.319 16.6109 17.4375 16.3125 17.4375H1.6875C1.38913 17.4375 1.10298 17.319 0.892005 17.108C0.681026 16.897 0.5625 16.6109 0.5625 16.3125V14.0625",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M0.5625 3.9375V1.6875C0.5625 1.38913 0.681026 1.10298 0.892005 0.892005C1.10298 0.681026 1.38913 0.5625 1.6875 0.5625H16.3125C16.6109 0.5625 16.897 0.681026 17.108 0.892005C17.319 1.10298 17.4375 1.38913 17.4375 1.6875V3.9375",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_562_1921",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
